module.exports = __webpack_public_path__ + "toBride1-we-p-n.56af7df3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-p-n.jpg
// module id = 3/Yo
// module chunks = 0